export default __webpack_public_path__ + "src/images/number_region-24d7f9.xml";